module.exports = __webpack_public_path__ + "static/media/share_facebook.65cc425f.webp";